var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "text-center mx-auto" }, [
    _c(
      "div",
      { staticClass: "flex flex-col" },
      _vm._l(
        _vm.$store.state.data.Steps[_vm.$store.state.activeStep].Options,
        function(option, index) {
          return _c(
            "button-option",
            {
              key: option.Id,
              attrs: { isActive: _vm.isActiveStep(index) },
              nativeOn: {
                click: function($event) {
                  if (_vm.isNewWindowOpened(option)) {
                    return
                  }
                  _vm.setSelectedTile(index)
                  _vm.startFlow(option)
                }
              },
              scopedSlots: _vm._u(
                [
                  option.TooltipTitle && option.TooltipBody
                    ? {
                        key: "tooltip",
                        fn: function() {
                          return [
                            _c("tooltip", { attrs: { settings: option } })
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [_vm._v("\n      " + _vm._s(option.Title) + "\n      ")]
          )
        }
      ),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }